import script from "./LoggedUserData.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoggedUserData.vue?vue&type=script&lang=ts&setup=true"

export default script